<template>
  <div class="pay-type-box">
    <div class="pay-box">
      <img
        class="pay-close"
        src="../assets/images/pay/close.png"
        @click="closePay"
      />
      <ul class="pay-type-list">
        <li class="active">
          <div class="paytype-box">
            <div>
              <img
                class="paytype-icon"
                src="../assets/images/pay/paytype01.png"
              />
              <span>微信支付</span>
            </div>
            <em></em>
          </div>
        </li>
      </ul>
      <div class="payConfirm">确认支付</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paytype: 1,
    };
  },
  methods: {
    paytypechoose() {},
    closePay() {
      this.$emit("closePayTypeChoose");
    },
  },
  mounted() {},
};
</script>

<style>
.pay-type-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.5);
}

.pay-box {
  width: 581px;
  height: 465px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: url("../assets/images/pay/payBg.png") no-repeat;
  background-size: 100% 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 120px;
}

.pay-box .pay-close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.pay-box .pay-type-list {
  padding: 0 38px;
}

.pay-box .pay-type-list li.active {
  border-color: #f3ae73;
}

.pay-box .pay-type-list .paytype-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pay-box .pay-type-list li.active .paytype-box em {
  background: url("../assets/images/pay/icon-checked.png") no-repeat;
  background-size: 100% 100%;
  border: 1px solid #fff;
}

.pay-box .pay-type-list li {
  text-align: left;
  padding: 3%;
  margin-top: 3%;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 0;
  cursor: pointer;
}

.pay-box .pay-type-list li .paytype-box img {
  display: inline-block;
  vertical-align: middle;
  width: 0.4rem;
  height: 0.4rem;
}

.pay-box .pay-type-list li .paytype-box span {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  margin-left: 10px;
}

.pay-box .pay-type-list li .paytype-box em {
  display: inline-block;
  width: 0.34rem;
  height: 0.34rem;
  border: 1px solid #c9c9c9;
  border-radius: 50px;
  vertical-align: middle;
  float: right;
}

.pay-box .payConfirm {
  max-width: 100px;
  display: block;
  text-align: center;
  margin: 7% auto;
  cursor: pointer;
  padding: 2% 8%;
  background-color: #dea53e;
  border-radius: 10px;
  color: white;
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
}

@media (max-width: 600px) {
  .pay-box {
    height: 90vw;
    max-width: 95vw;
    max-height: 95vw;
    padding-top: 23vw;
  }
  .pay-box .pay-type-list {
    padding: 0 5vw;
  }
  .pay-box .pay-close {
    width: 8vw;
    height: 8vw;
  }
  .pay-box .pay-type-list li .paytype-box span {
    font-size: 4vw;
  }
  .pay-box .pay-type-list li .paytype-box img {
    width: 8vw;
    height: 8vw;
  }
  .pay-box .pay-type-list li .paytype-box em {
    width: 7vw;
    height: 7vw;
  }
  .pay-box .payConfirm {
    font-size: 4vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payTypeChoose.vue